import Vue from "vue";
import { FormatDate } from "./utils";

Vue.filter("FormatDate", value => {
  const newValue = FormatDate(value, 'yyyy-MM-dd');
  return newValue;
});
